<!--手机端详情页-->
<template>
  <div>
    <!--logo-->
    <div class='logo'>
      <img src='../../assets/images/logo.png'>
    </div>

    <template>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="首页" name="homePage">
        </el-tab-pane>
        <el-tab-pane label="主营业务" name="mainBusiness">
          <div class='text'>
            <div class='content'>
              <h2 class='title'>{{this.tableData.title}} </h2>
              <p class='time'>{{this.tableData.releaseTime}} </p>
              <p class='ql-editor' v-html='tableData.content'></p>
            </div>
            <ul class='page'>
              <li>
        <span  :class="
                this.tableData.previousId === '0'
                  ? 'page1'
                  : this.tableData.previousId == null
                  ? 'page1'
                  : 'page2'
              " @click='previous()'>上一篇</span>
              </li>
              <li>
                <img src='../../assets/images/page.jpg'>
              </li>
              <li>
          <span  :class="
                this.tableData.nextId === '0'
                  ? 'page1'
                  : this.tableData.nextId == null
                  ? 'page1'
                  : 'page2'
              " @click='nextTitle()'>下一篇</span>
              </li>
            </ul>
          </div>
        </el-tab-pane>
        <el-tab-pane label="经典案例" name="case"></el-tab-pane>
        <el-tab-pane label="新闻中心" name="newsCenter">
          <div class='text'>
            <div class='content'>
              <h2 class='title'>{{this.tableData.title}} </h2>
              <p class='time'>{{this.tableData.releaseTime}} </p>
              <p class='ql-editor' v-html='tableData.content'></p>
            </div>
            <ul class='page'>
              <li>
        <span  :class="
                this.tableData.previousId === '0'
                  ? 'page1'
                  : this.tableData.previousId == null
                  ? 'page1'
                  : 'page2'
              " @click='previous()'>上一篇</span>
              </li>
              <li>
                <img src='../../assets/images/page.jpg'>
              </li>
              <li>
          <span  :class="
                this.tableData.nextId === '0'
                  ? 'page1'
                  : this.tableData.nextId == null
                  ? 'page1'
                  : 'page2'
              " @click='nextTitle()'>下一篇</span>
              </li>
            </ul>
          </div>
        </el-tab-pane>
        <el-tab-pane label="研究院" name="researchInstitute"></el-tab-pane>
        <el-tab-pane label="关于埃文" name="avi"></el-tab-pane>
      </el-tabs>
      <!--底部占位-->
      <div style='height: 80px;'>
      </div>
    </template>

    <!--底部选项卡-->
    <div class='bottom'>
      <ul>
        <li class='tab' @click="tabButton(1)">联系方式</li>
        <li class='tab' @click="tabButton(2)">加入低碳行业</li>
        <li class='tab' @click="tabButton(3)">合作网站</li>
      </ul>
      <p>企业节能减排与低碳发展综合解决方案提供商</p>
    </div>
  </div>

</template>

<script>
import homePage from './homePage.vue'
import mainBusiness from './mainBusiness.vue'
import trainingCenter from './trainingCenter.vue'
import newsCenter from './newsCenter.vue'
import customerStories from './customerStories.vue'
import aboutAvi from './aboutAvi.vue'
import platformPartners from './platformPartners.vue'
import footer from './footer.vue'
import expert from './expert.vue'
import { newsDetails, selectMobileCaseId, webBusinessId } from '../../api/auth'
import 'quill/dist/quill.core.css'

export default {
  created () {
    this.$nextTick(function () {
      if (this.$route.query.type != null && this.$route.query.type > 0) {
        this.id = this.$route.query.id
        this.type = this.$route.query.type
        if (this.type === '1') {
          this.selectMobileCaseId()
          this.nameType = '客户案例'
        } else if (this.type === '2') {
          this.nameType = '新闻中心'
          this.activeName = 'newsCenter'
          this.newsDetails()
        } else if (this.type === '3') {
          this.nameType = '主营业务'
          this.activeName = 'mainBusiness'
          this.webBusinessId()
        }
      }
    })
  },
  data () {
    return {
      src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
      fits: ['cover'],
      tabPosition: 'left',
      activeName: 'newsCenter',
      nameType: '',
      fit: 'fill', // 想要什么属性就在这个位置设置什么属性
      isChildUpdate1: true,
      isChildUpdate2: false,
      isChildUpdate3: false,
      qr_url: '',
      isChildUpdate4: false,
      isChildUpdate5: false,
      isChildUpdate6: false,
      isChildUpdate7: false,
      components: {
        child0: homePage,
        child1: mainBusiness,
        child2: trainingCenter,
        child3: newsCenter,
        child4: aboutAvi,
        child5: customerStories,
        child7: platformPartners,
        child8: expert,
        tail: footer
      },
      queryParams: {
        id: 1
      },
      // 是否显示弹出层
      open: false,
      content: '',
      releaseTime: '',
      id: null,
      type: null,
      enterpriseParams: {
        type: 6
      },
      dataList: [],
      typeName: '',
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      tableData: {
        content: '',
        title: '',
        nextId: '',
        previousId: '',
        releaseTime: ''
      }
    }
  },
  methods: {
    tabButton (raw) {
      if (raw === 1) {
        // 联系方式
        this.$router.push({
          path: '/mobileContacInformation',
          query: {}
        })
      } else if (raw === 2) {
        // 加入低碳
        this.$router.push({
          path: '/moblielowCarbonIndustry',
          query: {}
        })
      } else if (raw === 3) {
        // 合作伙伴
        this.$router.push({
          path: '/mobileCooperativePartner',
          query: {}
        })
      }
    },
    handleClick (tab, event) {
      if (tab.name === 'homePage') {
        this.$router.push({
          path: '/mobileIndex',
          query: {
          }
        })
      } else if (tab.name === 'mainBusiness') {
        this.$router.push({
          path: '/mobileMainBusiness',
          query: {
          }
        })
      } else if (tab.name === 'case') {
        this.$router.push({
          path: '/mobileCase',
          query: {
          }
        })
      } else if (tab.name === 'researchInstitute') {
        this.$router.push({
          path: '/mobileResearchInstituter',
          query: {
          }
        })
      } else if (tab.name === 'avi') {
        this.$router.push({
          path: '/mobileAboutAvi',
          query: {
          }
        })
      } else if (tab.name === 'newsCenter') {
        this.$router.push({
          path: '/mobileNewsCenter',
          query: {
          }
        })
      }
    },

    previous () {
      if (this.tableData.previousId === '0') {

      } else {
        this.$router.push({
          path: '/mobileDetailsPage',
          query: {
            id: this.tableData.previousId,
            type: this.type
          }
        })
      }
    },
    nextTitle () {
      if (this.tableData.nextId === '0') {

      } else {
        this.$router.push({
          path: '/mobileDetailsPage',
          query: {
            id: this.tableData.nextId,
            type: this.type
          }
        })
      }
    },
    /**  */
    newsDetails () {
      let that = this
      that.queryParams.id = that.id
      newsDetails(this.queryParams).then(res => {
        that.tableData.title = res.title
        that.tableData.releaseTime = res.releaseTime
        that.tableData.content = res.content
        that.tableData.previousId = res.previousId
        that.tableData.nextId = res.nextId
      })
    },
    /** 主营业务 */
    webBusinessId () {
      let that = this
      that.queryParams.id = that.id
      webBusinessId(this.queryParams).then(res => {
        that.tableData.title = res.name
        that.tableData.releaseTime = res.creteTime
        that.tableData.content = res.content
        that.tableData.previousId = res.previousId
        that.tableData.nextId = res.nextId
      })
    },
    /**  */
    selectMobileCaseId () {
      let that = this
      that.queryParams.id = that.id
      selectMobileCaseId(this.queryParams).then(res => {
        that.tableData.title = res.title
        that.tableData.releaseTime = res.releaseTime
        that.tableData.content = res.content
        that.tableData.previousId = res.previousId
        that.tableData.nextId = res.nextId
      })
    }
  }
}
</script>

<style lang="less">
img {
  width: 100%;
}
.text{
  width: 90%;
  margin: 20px auto;
  .content{
    min-height: 250px;
    .title{
      font-size: 16px;
      margin-bottom: 5px;
      color: #000;
      text-align: center;
    }
    .time{
      text-align: center;
      font-size: 14px;
      color: #999;
      margin-bottom: 5px;
    }
  }
  .page{
    margin-top: 20px;
    color: #333;
    li{
      font-family: " 黑体";
      float: left;
      width: 14%;
      height: 20px;
      .page1{
        color: #999;
      }
      .page2{
        color: #6ca03f;
      }
    }
    li:nth-child(2){
      width: 72%;
    }
    img{
      width: 90%;
      display: block;
      margin:2px auto 0;
    }
  }
}
//按钮
.but{
  background-color: #90bc4f;
  display: block;
  margin: 15px auto;
  width: 150px;
  font-size: 14px;
  height: 30px;
  line-height: 0px;
  letter-spacing:2px;
  border: 2px solid #98fcf4;
  border-radius:10px ;
  box-shadow: 0 5px 5px  rgba(0, 0, 0, .2);
}
//标题列表
.content{
  width: 90%;
  margin: 0 auto;
  font-size: 14px;
  text-align: center;
  li{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-family: SourceHanSansSC;
    overflow: hidden; /*内容会被修剪，并且其余内容是不可见的*/
    text-overflow: ellipsis; /*显示省略符号来代表被修剪的文本。*/
    white-space: nowrap; /*文本不换行*/
    cursor:pointer;
  }
}
.img{
  width: 92%;
  margin: 0 auto;
  li{
    width: 33.33%;
    height: 50px;
    float: left;
    margin-bottom: 10px;
    .block{
      margin: 0 5px;
      .el-image{
        height: 50px;
        display: block;
        margin: 0 auto;
      }
    }
  }
}
.el-row {
  &:last-child {
    margin-bottom: 0;
  }
}

//logo
.logo{
  img{
    width: 70%;
    display: block;
    margin:10px auto;
  }
}

//tabs样式
.el-tabs__item {
  border: 1px solid #fff;
  background-color: #90bc4f;
  width: 33.33%;
  font-size: 14px;
  color: #fff;
  height: 40px;
  line-height: 40px;
  float: left;
  display: block;
  text-align: center;
}
 .el-tabs__item.is-top:nth-child(2) {
  padding-left: 20px;
}
 .el-tabs__item.is-top:nth-child(7) {
  padding-left: 0px;
}
//底部选项卡
.bottom{
  background-color: #fff;
  height: 80px;
  width: 100%;
  position: fixed;
  bottom: 0;
  .tab{
    width: 33.33%;
    float: left;
    text-align: center;
    background-color: #90bc4f;
    border: 1px solid #fff;
    font-size: 14px;
    color: #fff;
    height: 40px;
    line-height: 40px;
  }
  p{
    font-size: 14px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    color:#90bc4f;
  }
}
.el-tabs__item.is-active {
  color: #fff;
  background-color: #73b649;
}
::v-deep .el-tab-pane{
  height:620px;
}
//去掉tab下划线
::v-deep .el-tabs__active-bar {
  width: 0px !important;
}
/*tabs 去掉el-tab-pane切换时的蓝色下划线*/
.el-tabs__active-bar {
  background-color: transparent !important;
}
</style>
